// extracted by mini-css-extract-plugin
export default {"content":"WcEM231nx0cLOLy3t77W","text":"wwEHPuKTaIbipl7QqeIa","key":"hkW7giqSiTXoR_OqWNr_"};